import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export const DiscoveryDocumentConfig = {
  url: environment.azureAD.url
}
export const AppAuthorization: AuthConfig = {
  redirectUri: environment.azureAD.redirectUri,
  responseType: environment.azureAD.responseType,
  strictDiscoveryDocumentValidation: environment.azureAD.strictDiscoveryDocumentValidation,
  issuer: environment.azureAD.issuer,
  //tokenEndpoint: environment.azureAD.tokenEndpoint,
  //loginUrl: environment.azureAD.loginUrl,
  //logoutUrl: environment.azureAD.logoutUrl,
  clientId: environment.azureAD.clientId,
  scope: environment.azureAD.scope,
  //skipIssuerCheck: environment.azureAD.skipIssuerCheck,
  clearHashAfterLogin: environment.azureAD.clearHashAfterLogin,
  oidc: true,
  silentRefreshRedirectUri: environment.azureAD.silentRefreshRedirectUri,
  silentRefreshShowIFrame: false,
  //silentRefreshMessagePrefix: 'PEPE',
  silentRefreshTimeout: 60,
  showDebugInformation: environment.azureAD.showDebugInformation
}

export const resetPolicy = {
  value: environment.azureAD.resetPolicy
}
export const tenantName = {
  value: environment.azureAD.tenantName
}
